import React, { useEffect, useState } from 'react';
const COUNTDOWN_KEY = 'eve_countdown_end';
export function CountdownBanner() {
  // Get or set end time (16 hours from first load)
  const getEndTime = () => {
    const stored = localStorage.getItem(COUNTDOWN_KEY);
    if (stored) {
      return new Date(stored);
    }
    const now = new Date();
    const endTime = new Date(now.getTime() + 16 * 60 * 60 * 1000);
    localStorage.setItem(COUNTDOWN_KEY, endTime.toISOString());
    return endTime;
  };
  const calculateTimeLeft = () => {
    const endTime = getEndTime();
    const now = new Date();
    const difference = endTime.getTime() - now.getTime();
    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor(difference / (1000 * 60 * 60) % 24),
      minutes: Math.floor(difference / 1000 / 60 % 60),
      seconds: Math.floor(difference / 1000 % 60)
    };
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Format dates for display
  const formatDate = (date: Date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${day}.${month}.`;
  };
  // Display date range: 5 days ago to end time
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 5);
  const endDate = getEndTime();
  return <div className="bg-gradient-to-r from-pink-100 via-yellow-50 to-yellow-100 py-6 border-b border-gray-200" data-id="element-29">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <div className="text-center" data-id="element-31">
          <h2 className="text-red-800 font-bold text-lg mb-4 uppercase tracking-wide" data-id="element-32">
            Einmaliges Angebot vom {formatDate(startDate)} bis{' '}
            {formatDate(endDate)}*
          </h2>
          <div className="flex justify-center gap-4 mb-3" data-id="element-33">
            <div className="bg-white rounded-lg px-4 py-3 shadow-sm min-w-[70px]" data-id="element-34">
              <div className="text-3xl font-bold text-gray-900" data-id="element-35">
                {String(timeLeft.days).padStart(2, '0')}
              </div>
              <div className="text-xs text-gray-600 uppercase font-medium" data-id="element-36">
                Tage
              </div>
            </div>
            <div className="bg-white rounded-lg px-4 py-3 shadow-sm min-w-[70px]" data-id="element-37">
              <div className="text-3xl font-bold text-gray-900" data-id="element-38">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <div className="text-xs text-gray-600 uppercase font-medium" data-id="element-39">
                Stunden
              </div>
            </div>
            <div className="bg-white rounded-lg px-4 py-3 shadow-sm min-w-[70px]" data-id="element-40">
              <div className="text-3xl font-bold text-gray-900" data-id="element-41">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <div className="text-xs text-gray-600 uppercase font-medium" data-id="element-42">
                Minuten
              </div>
            </div>
            <div className="bg-white rounded-lg px-4 py-3 shadow-sm min-w-[70px]" data-id="element-43">
              <div className="text-3xl font-bold text-gray-900" data-id="element-44">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <div className="text-xs text-gray-600 uppercase font-medium" data-id="element-45">
                Sekunden
              </div>
            </div>
          </div>
          <p className="text-sm text-gray-700 italic" data-id="element-46">
            *Nur solange der Vorrat reicht
          </p>
        </div>
      </div>
    </div>;
}